import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Menu } from '../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    private path = environment.apiUrl;
    constructor(private http: HttpClient) {}
    getMenu() {
        return this.http.get<Menu>(`${this.path}/luxura-products/menu`);
    }
}
